import React from 'react'
import {Button, Dialog, DialogContent} from '@material-ui/core'

import {useTranslation} from 'react-i18next'
import useStyles from 'pages/LicenseAnalysisOrganization/Component/style'
import DatePicker from 'react-datepicker'

type DialogActiveProductProps = {
  open: boolean
  onClose: () => void
  listRegister?: string[]
  productName?: string
  onConfirm: (startDate: Date | null, endDate: Date | null) => void
}

const DialogConfirm = (props: DialogActiveProductProps) => {
  const {open, onClose, listRegister, productName, onConfirm} = props
  const [packageStartDate, setPackageStartDate] = React.useState<Date | null>(
    null,
  )
  const [packageExpireDate, setPackageExpireDate] = React.useState<Date | null>(
    null,
  )
  const classes = useStyles()
  const {t} = useTranslation()

  const handleConfirm = () => {
    onConfirm(packageStartDate, packageExpireDate)
    onClose()
    setPackageStartDate(null)
    setPackageExpireDate(null)
  }

  return (
    <Dialog open={open} onClose={onClose} className={classes.container}>
      <DialogContent className={classes.contentWrap}>
        {listRegister && listRegister.length > 0 && (
          <>
            <div className={classes.headerDialog}>
              {t('IRegisterAnalysisLicense')}
            </div>
            <div className={classes.infoCard}>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>
                  {t('IProductNameSelect')}:
                </span>
                <span className={classes.infoValue}>{productName}</span>
              </div>

              <div className={classes.infoLabel}>{t('IDesignatedAgency')}:</div>
              {listRegister?.map((item, index) => (
                <div className={classes.infoValue} key={`${item} ${index}`}>
                  * {item}
                </div>
              ))}

              <div className={classes.infoLabel}>{t('ILicenseStartDate')}:</div>

              <DatePicker
                selected={packageStartDate}
                minDate={new Date()}
                maxDate={packageExpireDate ?? undefined}
                onChange={(date) => setPackageStartDate(date)}
                dateFormat='yyyy-MM-dd'
                placeholderText='YYYY-MM-DD'
                className={classes.input}
                popperPlacement='right'
              />

              <div className={classes.infoLabel}>
                {t('ILicenseExpirationDate')}:
              </div>

              <DatePicker
                selected={packageExpireDate}
                minDate={packageStartDate ?? new Date()}
                onChange={(date) => setPackageExpireDate(date)}
                dateFormat='yyyy-MM-dd'
                placeholderText='YYYY-MM-DD'
                className={classes.input}
                popperPlacement='right'
              />
            </div>
          </>
        )}

        <div className={classes.listBtn}>
          <Button
            color='primary'
            variant='contained'
            onClick={() => {
              setPackageExpireDate(null)
              onClose()
            }}
          >
            {t('ICancel')}
          </Button>
          <Button color='primary' variant='contained' onClick={handleConfirm}>
            {t('IConfirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogConfirm
